import React from "react";
import offline_css from "../offline.module.css";
export default function Alert({ error, set_error }) {
  return (
    <div
      className={
        offline_css["alert-main"] +
        " mx-5" +
        (!error ? "" : " " + offline_css["alert-error"])
      }
    >
      <div
        className={"alert alert-danger show mt-5" + (!error ? " fade" : "")}
        role="alert"
      >
        <strong>{error}</strong>
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={() => set_error((prev) => ({ ...prev, error: "" }))}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  );
}
